import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError, handleQueryErrorAndSuccess,
} from "../../../helpers/utils/RtkQueryUtils";

export const sortHoaFeeTypeApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchSortHoaFeeTypeApi: build.query({
            query: () => {
                return {
                    url: `/ajax/get-all-fee-types`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['sortHoaFeeType'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateSortHoaFeeTypeApi: build.mutation({
            query: (listIds) => {
                return {
                    url: `/ajax/update-hoa-fee-type-order`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: listIds
                };
            },
            invalidatesTags: ['sortHoaFeeType'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Fee Type Order");
            },
        }),
    }),
});
export const {
    useSearchSortHoaFeeTypeApiQuery,
    useUpdateSortHoaFeeTypeApiMutation
} = sortHoaFeeTypeApi;